import { render, staticRenderFns } from "./TableCompanyGroup.vue?vue&type=template&id=ca616ff4&scoped=true&"
import script from "./TableCompanyGroup.vue?vue&type=script&lang=js&"
export * from "./TableCompanyGroup.vue?vue&type=script&lang=js&"
import style0 from "./TableCompanyGroup.vue?vue&type=style&index=0&id=ca616ff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca616ff4",
  null
  
)

export default component.exports